module.exports = __webpack_public_path__ + "static/media/inprogress.870ba156.svg";